define.alias("shared/components/shared/ai-credits/info", "media/components/shared/ai-credits/info");